<template>
  <div class="space-y-8">
    <header class="text-center space-y-4">
      <h1 class="text-4xl font-bold text-nirvana-blue">
        อวยพรวันเกิดให้น้องเนอร์กัน~
      </h1>
      <p class="text-gray-600 max-w-2xl mx-auto">
        แบ่งปันคำอวยพรวันเกิดให้น้องตุ๊กตาสุดน่ารัก<br>เนอร์วาน่าของพวกเราเหล่าแฮนด์เลอร์!
      </p>
      <div class="flex flex-col items-center gap-2">
        <button
          class="dollhouse-button inline-block opacity-70 cursor-not-allowed"
          disabled
        >
          หมดเวลาเขียนคำอวยพรแล้ว ขอขอบคุณทุกท่านที่เข้าร่วมน้า
        </button>
        <p class="text-sm text-gray-500">
          มีคำอวยพรทั้งหมด {{ displayTotalWishes }} คำอวยพร
        </p>
      </div>
    </header>

    <div
      ref="containerRef"
      class="scroll-container space-y-6 p-4"
    >
      <!-- Developer Wish Card always appears first -->
      <DevWishCard
        v-if="devWish"
        :wish="devWish"
      />

      <template v-if="wishes.length">
        <WishCard
          v-for="wish in wishes"
          :key="wish.id"
          :wish="wish"
        />
      </template>

      <LoadingSpinner v-if="loading" />

      <p
        v-if="!loading && !wishes.length && !devWish"
        class="text-center text-gray-500"
      >
        ยังไม่มีใครอวยพรน้องเลย~ ทำไมไม่มาเป็นคนแรกล่ะ!
      </p>

      <p v-if="error" class="text-center text-red-500">
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script setup>
// Use aliases '@' for importing components and composables
import { WishCard, LoadingSpinner } from '@/components'  // Ensure this path is correct
import DevWishCard from '@/components/DevWishCard.vue'  // Import the new Developer Wish Card
import { useWishes, useInfiniteScroll } from '@/composables'  // Ensure this path is correct
import { ref, onMounted, computed } from 'vue'

const {
  wishes,
  loading,
  error,
  hasMore,
  loadWishes,
  totalCount // Now properly destructured from useWishes
} = useWishes()

const { containerRef } = useInfiniteScroll(loadWishes, {
  threshold: 100
})

// Create a ref for the developer wish
const devWish = ref(null)

// Compute total wishes count (including dev wish if present)
const totalWishes = computed(() => {
  // If totalCount is provided by the API, use that
  if (totalCount && totalCount.value !== undefined) {
    return totalCount.value + (devWish.value ? 1 : 0);
  }
  
  // Fallback to counting loaded wishes
  return wishes.value.length + (devWish.value ? 1 : 0);
})

// Create a display version that's always at least 1 when dev wish exists
const displayTotalWishes = computed(() => {
  const count = totalWishes.value;
  return count > 0 ? count : devWish.value ? 1 : 0;
})

// Load the developer wish on component mount
onMounted(async () => {
  try {
    // This is a placeholder - you'll need to replace this with your actual API call
    // You might want to get this from a separate API endpoint or from a special place in your database
    devWish.value = {
      id: 'dev-wish',
      number: 'DEV',
      name: 'Handlers ทีมพัฒนา - Kanosume \'Kurumina\' Umiki',
      twitter: 'Prachameow', // Replace with your actual Twitter handle
      message: 'สุขสันต์วันเกิดน้องเนอร์นะครับ! ขอบคุณที่เป็นแรงบันดาลใจให้กับพวกเราทุกคน ขอให้เนอร์มีความสุขมากๆนะ และหวังว่าทุกคนจะสนุกกับเว็บไซต์นี้ที่พวกเราตั้งใจทำเพื่อวันพิเศษของน้องนะครับ~ ดื่มชาซู่ให้อร่อยน้า',
      createdAt: '2025-03-14T16:38:38.299Z',
      fanart: 'https://nirvana-fa-host.nephele.in.th/nir-cola.png'  // Replace with actual fanart URL or remove if not needed
    }
  } catch (e) {
    console.error('Failed to load developer wish:', e)
  }
})
</script>

<style scoped>
/* Fix scrolling behavior in Safari */
.scroll-container {
  max-height: 800px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* Enables smooth scrolling in Safari */
}
</style>
